module.exports = __webpack_public_path__ + "img/b56d11b.jpg";